export default __webpack_public_path__ + "static/media/smile-5.3db3547d.svg";